import React, { useEffect } from 'react';
import './About.css';
import { ActiveNav } from '../../types/navigation/ActiveNav';

import Mama from '../../static/images/mama-about.jpeg';
import { Helmet } from 'react-helmet';

type Props = {
  setActiveNav: (x: ActiveNav) => void;
};

const About: React.FC<Props> = ({ setActiveNav }: Props) => {
  useEffect(() => {
    setActiveNav(ActiveNav.ABOUT);
  }, [setActiveNav]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className='About'>
      <Helmet>
        <title>About - MARTINA JUNKER ART</title>
      </Helmet>
      <div className='AboutInner'>
        <div className='image-container'>
          <img src={Mama} alt='Majunkerart' />
        </div>
        <div className='content-container'>
          <div className='german-container'>
            <p>
              Mit meiner Kunst möchte ich den Zauber der Natur einfangen und das
              Gefühl widerspiegeln, das auf einer Wanderung durch die Natur
              entsteht, bei der man sich unbeschwert und frei fühlt, wie ein
              Kind auf Entdeckungstour. In diesen Momenten bemerkt man wieder
              die kleinen, oft unscheinbaren Dinge, in denen so viel Schönheit
              steckt. Viele meiner Bilder zeigen Blüten, die häufig unbemerkt
              bleiben, aber eine ganz besondere Faszination ausstrahlen.
            </p>
            <p>
              Die Schönheit der Natur, die Harmonie der Farben, eine fröhliche,
              beschwingte Stimmung, Optimismus und Leichtigkeit, all das möchte
              ich zum Ausdruck zu bringen. Mit meinen Bildern lade ich Sie ein,
              sich eine geheimnisvolle Energiequelle in Ihr Zuhause zu holen –
              ein Stück Natur, das stets die Seele berührt.
            </p>
            <p>
              Nach der Ausbildung zur Modegraphikerin an der Meisterschule für
              Mode München, arbeitete ich mehrere Jahre als Graphikerin in
              verschiedenen Werbeagenturen. Danach forderten vier Kinder meine
              ganze Aufmerksamkeit und Kreativität. Jetzt lebe ich mit meinem
              Mann in Quickborn, in der Nähe von Hamburg, die Kinder sind groß
              und flügge und ich habe wieder Zeit mich dem Malen zu widmen.
            </p>
          </div>
          <div className='english-container'>
            <p>
              With my art, I want to capture the magic of nature and reflect the
              feeling that arises when hiking through nature, when you feel
              lighthearted and free, like a child on a journey of discovery. In
              these moments, you notice the small, often inconspicuous things
              that contain so much beauty. Many of my paintings show flowers
              that often go unnoticed but exude a very special fascination.
            </p>
            <p>
              The beauty of nature, the harmony of colors, a cheerful, lively
              atmosphere, optimism, and lightness—I want to express all of this.
              With my paintings, I invite you to bring a mysterious source of
              energy into your home — a piece of nature that always touches the
              soul.
            </p>
            <p>
              After training as a fashion graphic designer at the Master School
              of Fashion in Munich, I worked for several years as a graphic
              designer in various advertising agencies. After that, four
              children demanded all my attention and creativity.
            </p>
            <p>
              I now live with my husband in Quickborn, near Hamburg, the
              children are grown and fledged and I have time again to devote
              myself to painting.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
